let referer: string | undefined;

export function getChangeDepositLimitReferer():string | undefined {
    return referer;
}

export function setChangeDepositLimitReferer(value: string): string {
    return referer = value;
}
